import { v4 as uuidv4 } from "uuid";
import { CONFIG } from "~/config";
import { IAcceptInvitationResponse, IDescriptionResponse, IError, IInvitationsMeResponse } from "./interfaces";

const ENDPOINT_URL = "/share-position/invitations";

export async function invitationsMe(): Promise<IInvitationsMeResponse> {
	const response = await fetch(`${CONFIG.requestUrl}${ENDPOINT_URL}/me`, {
		method: "GET",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
	});

	if (response?.status === 200) {
		const json: IInvitationsMeResponse = await response.json();

		return json;
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}

export async function acceptInvitation(id: string): Promise<IAcceptInvitationResponse> {
	const response = await fetch(`${CONFIG.requestUrl}${ENDPOINT_URL}/${encodeURIComponent(id)}`, {
		method: "POST",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
	});

	if (response?.status === 200) {
		const json: IAcceptInvitationResponse = await response.json();

		return json;
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}

export async function deleteInvitation(id: string): Promise<IDescriptionResponse> {
	const response = await fetch(`${CONFIG.requestUrl}${ENDPOINT_URL}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
	});

	if (response?.status === 200) {
		const json: IDescriptionResponse = await response.json();

		return json;
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}
